<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <BoardingClassDateReportFilter @onFilterChanged="refresh" />
    </v-card>
    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView :content="'Tìm kiếm'" />
    </div>
    <v-card v-else class="ma-6" outlined>
      <BoardingClassDateReportTable ref="boarding-class-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import BoardingClassDateReportFilter from './components/BoardingClassDateReportFilter.vue'
import BoardingClassDateReportTable from './components/BoardingClassDateReportTable.vue'

export default {
  components: {
    BoardingClassDateReportFilter,
    BoardingClassDateReportTable,
    StudentBlankView,
  },
  data() {
    return {
      action: {
        state: 'select',
      },
      filters: null,
    }
  },
  methods: {
    refresh(query) {
      this.action.state = 'filtered'
      this.filters = query
      this.$nextTick(() => {
        this.$refs['boarding-class-data-table'].searchboardingDateSessionClass()
      })
    },
  },
}
</script>
